import { createSelector } from 'reselect'
import { getNestedObject } from 'Utility/globalMethods'
import { ELIGIBLE_ROLES } from 'Schemas/constants'

export const getNested = (state, props) => getNestedObject(state, props)

export const getFormikForm = (state, name) => state?.formik?.formikForm?.[name] || {}

export const getUserTenantId = (state) => state?.user?.tenantId || ''

export const getUserMerchantId = (state) => state?.user?.merchant?.merchantId || ''

export const userProfileType = (state) => state?.user?.userProfile?.user?.roles?.[0]?.name || ''

export const getTerminalId = (state) => state?.operations?.operation?.terminalId || ''

export const getUserId = (state) => state?.user?.userProfile?.user?.id || ''

export const getUserRoles = (state) => state?.user?.roles || []

export const getReduxLocation = (state) => state.router

export const getOperationTerminalId = (state) => state?.operations?.operationTerminalId

export const getOrderId = (state) => state.OrderManagement?.order?.orderStatus?.order?.orderId

export const getTerminalIdList = (state) => state?.user?.terminalIdList || []

export const getSelectedTerminalId = (state) => state?.TerminalsManagement?.selectedTerminalId || null

export const getOrderPagination = (state) => state.OrderManagement?.pagination

export const getPopupData = (state) => state?.popup?.popupData || {}

export const getSelectedProcessingRule = (state) => state?.TerminalsManagement?.selectedRule || null

export const getApmList = (state) => state.TerminalsManagement?.apmList

export const getPaypalExternalLink = (state) => state.TerminalsManagement?.paypalExternalLink

export const getPaypalPayIn3 = (state) => state.TerminalsManagement?.paypalPayIn3 || null

export const getSelectedVas = (state) => state?.TerminalsManagement?.selectedVas || null

export const getStructures = (state) => state.TerminalsManagement?.structures || null

export const getStep = (state) => state.TerminalsManagement?.disputelessActivationStep || 1

export const getUserInfo = (state) => state?.user || {}

export const getUserUiTheme = (state) => state?.user?.userProfile?.merchant?.uiTheme || ''

// @generator selectors:single

export const userPermissions = createSelector([getUserRoles], (roles) => {
  if (roles && roles.length) {
    const mainRole = roles.find((role) => ELIGIBLE_ROLES.includes(role.name))
    return mainRole ? mainRole.permissions : []
  }
  return []
})

export const getprimaryButtonLoadingPopup = createSelector(
  [getPopupData, (state) => state],
  (data, state) => state?.loading?.[data.primaryButtonLoading] || false
)

export const userProfileInfo = createSelector([getUserInfo], (userInfo) => userInfo || {})

export const isSSOUser = createSelector(
  [getUserRoles], (roles) => {      
    if (roles && roles.length > 0) {
      const ssoRole = roles.some((role) => (role.name).startsWith('NB'))
      return ssoRole
    }
    return false
  })
// @generator selectors:memoized
